/** PURE_IMPORTS_START .._.._Observable,.._.._operator_isEmpty PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { isEmpty } from '../../operator/isEmpty';
Observable.prototype.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/isEmpty.js
// module id = ./node_modules/rxjs/_esm5/add/operator/isEmpty.js
// module chunks = vendor